module.exports = __webpack_public_path__ + "media/images/profile-a3cd9dc2d67b40fa722eedd86cc054f2.jpg";